import React from 'react';
import { Github, Phone, Mail, CodeXml } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-top-fade section-glow-top compact-footer py-12 px-4">
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-8 md:space-y-0">
          {/* Logo and tagline */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start space-x-3 mb-2">
              <div className="w-9 h-9 bg-gradient-to-br from-indigo-400 to-purple-500 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-400/30">
                <CodeXml className="w-5 h-5 text-white" strokeWidth={2} aria-hidden="true" />
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
                TukeWIN
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-wrap justify-center gap-8 text-sm">
            <div className="space-y-2">
              <h4 className="font-semibold text-white">Pages</h4>
              <div className="space-y-1 text-slate-400">
                <div><a href="/" className="hover:text-white transition-colors">Home</a></div>
                <div><a href="/for-companies" className="hover:text-white transition-colors">For Companies</a></div>
                <div><a href="/software-protection" className="hover:text-white transition-colors">Software Protection</a></div>
                <div><a href="/case-studies" className="hover:text-white transition-colors">Case Studies</a></div>
              </div>
            </div>
            <div className="space-y-2">
              <h4 className="font-semibold text-white">Company</h4>
              <div className="space-y-1 text-slate-400">
                <div><a href="/blog" className="hover:text-white transition-colors">Blog</a></div>
                <div><a href="/contact" className="hover:text-white transition-colors">Contact</a></div>
              </div>
            </div>
            <div className="space-y-2">
              <h4 className="font-semibold text-white">Contact</h4>
              <div className="space-y-1 text-slate-400">
                <div>
                  <a href="tel:+421952175301" className="hover:text-white transition-colors flex items-center gap-2">
                    <Phone className="h-3.5 w-3.5" />
                    +421 952 175 301
                  </a>
                </div>
                <div>
                  <a href="mailto:administrator@tuke.win" className="hover:text-white transition-colors flex items-center gap-2">
                    <Mail className="h-3.5 w-3.5" />
                    administrator@tuke.win
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex space-x-4">
            <a
              href="https://github.com/tukewin"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-slate-700/50 rounded-lg hover:bg-slate-600/50 transition-colors hover-lift"
            >
              <Github className="h-4 w-4" />
            </a>
            <a
              href="https://discord.gg/PfTTpSVCVZ"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 bg-slate-700/50 rounded-lg hover:bg-slate-600/50 transition-colors hover-lift"
              aria-label="Join our Discord server"
            >
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 text-center space-y-2">
          <p className="text-slate-400 text-sm">
            &copy; {currentYear} TukeWIN. All rights reserved.
          </p>
          <p className="text-slate-500 text-xs max-w-4xl mx-auto">
            TukeWIN is not affiliated with or endorsed by Technická univerzita v Košiciach. All content is educational and based on publicly available material.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
